module.exports = __webpack_public_path__ + "0.1.2/img/mean-select.566d38ae.jpeg";